const initialState = {amount: 0, reason: "", isActive: false}

const cashPayout = (state = initialState, {type, payload}) => {
  switch (type) {
    case "CASH_PAYOUT.CHANGE":
      return {...state, [payload.name]: payload.value}
    case "CASH_PAYOUT.CANCEL":
      return initialState
    case "CASH_PAYOUT.START":
      return {...state, isActive: true, date: payload}
    default:
      return state
  }
}

export default cashPayout
